export const environment = {
  // domain: "http://localhost/api",
  domain: "http://localhost/api",
  // domain: "http://localhost/api",
  serverName: "TEST",
}